const COMPANY_VARIABLE = 'company'
// ! TODO: we will need to get rid of from that legacy after proper migration
// `deadline_display`, not `deadline`: the email context supplies the whole sentence through
// the one renderer, so the template has to name that. See backend/candidates/deadline.py and
// message migration 0010, which rewrote existing rows to match.
const DEADLINE_VARIABLE = 'deadline_display'
const LEGACY_DEADLINE_VARIABLE = 'deadline'
const NAME_VARIABLE = 'name'
const URL_VARIABLE = 'url'
const CONTACT_EMAIL = 'contact_email'

const VARIABLES = {
  COMPANY_VARIABLE,
  DEADLINE_VARIABLE,
  NAME_VARIABLE,
  URL_VARIABLE,
  CONTACT_EMAIL,
}

export const getVariables = language => {
  const variables = [
    {
      key: VARIABLES.COMPANY_VARIABLE,
      label: { en: 'company', nb: 'firma' }[language],
    },
    {
      key: VARIABLES.DEADLINE_VARIABLE,
      label: { en: 'deadline', nb: 'frist' }[language],
      aliases: [LEGACY_DEADLINE_VARIABLE],
    },
    {
      key: VARIABLES.NAME_VARIABLE,
      label: { en: 'full name', nb: 'fullt navn' }[language],
    },
    { key: VARIABLES.URL_VARIABLE, label: { en: 'url', nb: 'url' }[language] },
    {
      key: VARIABLES.CONTACT_EMAIL,
      label: { en: 'ebber@ebber.com', nb: 'ebber@ebber.com' }[language],
    },
  ]

  return variables
}

export const SENDER_FIELD = 'sender'
export const SUBJECT_FIELD = 'subject'
export const MESSAGE_FIELD = 'message'

export const getDefaultValues = () => ({
  [SENDER_FIELD]: '',
  [SUBJECT_FIELD]: '',
  [MESSAGE_FIELD]: null,
})
